// import BussinessManagement from "components/bussiness-tabs/BussinessManagement";
import Statistics from "../statistics/Statistics";
import l1 from "../../../assets/images/superadmin/l1 (4).svg";
import l3 from "../../../assets/images/superadmin/l1 (2).svg";
import l2 from "../../../assets/images/superadmin/l1 (3).svg";
import l4 from "../../../assets/images/superadmin/l1 (1).svg";
// import ManagementSidebar from "components/common/ManagementSidebar";

function HomePage() {
  return (
    <div className="w-100 mt-2 d-flex">
      {/* <ManagementSidebar /> */}
      <div className="container">
        <div className="d-flex flex-wrap">
          <div className="col-md-3 col-6 ">
            <Statistics
              title="تعداد کل تامین کنندگان"
              type={1}
              txt="تامین کننده"
              number={145}
              icon={l1}
            />
          </div>
          <div className="col-md-3 col-6 ">
            <Statistics
              title="تعداد تامین کنندگان فعال"
              type={2}
              txt="تامین کنند فعال"
              number={145}
              icon={l2}
            />
          </div>
          <div className="col-md-3 col-6 ">
            <Statistics
              title="تعداد سوپر مارکت ها"
              type={3}
              txt="سوپرمارکت"
              number={145}
              icon={l3}
            />
          </div>
          <div className="col-md-3 col-6 ">
            <Statistics
              title="تعداد پروتئینی ها"
              type={4}
              txt="پروتئینی"
              number={145}
              icon={l4}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
